module.exports = "https://p.cds.unp.clasificados.pe/bg-empleos.a794cbf9278384bffad4fc413315f7b4.jpg";